import { Link, NavLink } from "react-router-dom";
import { NavItem } from "./useNavLinks";

type NavItemLinkProps = {
  item: NavItem;
  className?: string;
  onClick?: () => void;
  highlightActive?: boolean;
};

// Renderiza um NavItem como link interno (react-router) ou externo (nova aba).
export default function NavItemLink({ item, className, onClick, highlightActive }: NavItemLinkProps) {
  if (item.href) {
    return (
      <a href={item.href} className={className} onClick={onClick} target="_blank" rel="noopener noreferrer">
        {item.label}
      </a>
    );
  }
  if (highlightActive) {
    return (
      <NavLink to={item.to ?? "/"} className={className} onClick={onClick}>
        {item.label}
      </NavLink>
    );
  }
  return (
    <Link to={item.to ?? "/"} className={className} onClick={onClick}>
      {item.label}
    </Link>
  );
}
